import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Eye, Key, ArrowRight } from 'lucide-react';
import SEO from '@/components/SEO';

const steps = [
  { num: '1', title: 'Enquire', desc: 'Tell us what you\'re looking for and where. We\'ll take it from there.', icon: MessageSquare },
  { num: '2', title: 'View & decide', desc: 'Visit a studio, see the space, and decide if it\'s right for you.', icon: Eye },
  { num: '3', title: 'Move in and focus on your clients', desc: 'We\'ll get you set up quickly so you can focus on your clients.', icon: Key },
];

export default function HowItWorksPage() {
  return (
    <div data-testid="how-it-works-page">
      <SEO title="How It Works" description="Enquire, view a studio, move in. A simple 3-step process to get your own private studio." path="/how-it-works" />
      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] tracking-tight mb-4">
            A simple way to get your own studio
          </h1>
          <p className="text-base text-[#5C5C55] max-w-md mx-auto">
            From first enquiry to getting started — a simple, guided process.
          </p>
        </div>
      </section>

      <section className="pb-16 sm:pb-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-8">
          <div className="space-y-6">
            {steps.map((step, i) => (
              <div key={step.num}
                className={`bg-white rounded-2xl border border-[#E5E2DC] p-8 sm:p-10 shadow-[0_2px_10px_rgba(0,0,0,0.02)] animate-fade-in stagger-${i + 1}`}
                data-testid={`step-${step.num}`}>
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-2xl bg-[#E8EDE5] flex items-center justify-center shrink-0">
                    <step.icon className="w-6 h-6 text-[#3A4035]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <p className="text-[10px] text-[#8A8B85] uppercase tracking-wider font-semibold mb-1">Step {step.num}</p>
                    <h3 className="font-heading text-xl font-medium text-[#1A1A1A] mb-2">{step.title}</h3>
                    <p className="text-sm text-[#5C5C55] leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-14">
            <p className="text-sm text-[#5C5C55]/80 mb-4">View a studio. See how it works. Decide with confidence.</p>
            <Link to="/book-a-viewing" className="inline-flex items-center gap-2 bg-[#3A4035] text-white rounded-full px-7 py-3.5 text-sm font-medium hover:bg-[#2B3027] transition-colors" data-testid="hiw-cta">
              Book a viewing <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
            <p className="text-sm text-[#8A8B85] mt-4">No pressure. No obligation. Just come and see.</p>
            <p className="text-sm text-[#5C5C55]/70 mt-2">Studios are limited — each space is intentionally one of one.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
